import { useCallback } from "react";
import notify from "devextreme/ui/notify";
import { unflattenObject } from "../../../utils/objectUtils.js";
import { getEncryptionKey } from "../services/formFileService.js";
const XLSX = require("xlsx");

export default function useFileUpload({ docRef, updateState, updatePhones, executeFunctionByUid }) {
  const encryptionKey = getEncryptionKey();

  const handleUploadFile = useCallback((e) => {
    updateState({
      ownersNames: "",
      phonesNumbers: [],
      sendApendixPopupVisible: false,
    });

    const file = e.value[0];
    let fileName = file.name;

    if (fileName.endsWith(".txt.json")) {
      fileName = fileName.replace(".json", "");
    }

    if (fileName.endsWith(".txt") || fileName.endsWith(".encrypt")) {
      const fileReader = new FileReader();
      fileReader.readAsText(file, "UTF-8");
      try {
        fileReader.onload = (evt) => {
          const data = fileName.includes("encrypted")
            ? encryptionKey.decrypt(fileReader.result)
            : evt.target.result;
          let filteredData = JSON.parse(data);
          // Remove stale file references at root level (old flat format)
          Object.keys(filteredData).forEach((key) => {
            if (key.includes("fileUploader")) delete filteredData[key];
          });
          // Remove stale file references nested under tabs (HogeryForm format: [tabId][fieldUid])
          Object.values(filteredData).forEach((tabVal) => {
            if (!tabVal || typeof tabVal !== "object") return;
            const instances = Array.isArray(tabVal) ? tabVal : [tabVal];
            instances.forEach((instance) => {
              if (!instance || typeof instance !== "object") return;
              Object.keys(instance).forEach((uid) => {
                const val = instance[uid];
                // A serialized File becomes {} — clear it so the field shows empty
                if (val && typeof val === "object" && !(val instanceof File) && !Array.isArray(val) && Object.keys(val).length === 0) {
                  instance[uid] = null;
                }
                if (Array.isArray(val) && val.length > 0 && typeof val[0] === "object" && !(val[0] instanceof File) && Object.keys(val[0]).length === 0) {
                  instance[uid] = null;
                }
              });
            });
          });
          if (data === false) {
            notify("טעינת הקובץ נכשלה, יש לוודא שמדובר בקובץ שמתאים לטופס", "error", 10000);
          } else {
            docRef.current = filteredData;
            executeFunctionByUid("RunAfterLoad");
            const names = filteredData.owner.map(
              (item) => `${item.firstName} ${item.lastName}  `
            );
            updateState({ ownersNames: names });
          }
          updatePhones();
        };
      } catch (error) {
        notify("משהו השתבש.. נסה שנית", "error", 3000);
      }
    } else if (fileName.endsWith(".xlsx")) {
      const fileReader = new FileReader();
      fileReader.readAsBinaryString(file);
      fileReader.onload = (evt) => {
        const data = evt.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        let filteredData = unflattenObject(jsonData[0]);
        docRef.current = filteredData;
        const names = filteredData.owner.map(
          (item) => `${item.firstName} ${item.lastName}  `
        );
        updateState({ ownersNames: names });
        updatePhones();
        executeFunctionByUid("OnFileLoaded");
      };
    } else {
      notify("Unsupported file format. Please upload a TXT, ENCRYPT, or XLSX file.", "error", 5000);
    }
  }, [docRef, updateState, updatePhones, executeFunctionByUid, encryptionKey]);

  return { handleUploadFile };
}
